import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    width={19.649}
    height="6.8mm"
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 13874 18147"
    {...props}
  >
    <path
      d="M7135 6522V1014h2641V0H4149v1014h2634v5507L0 12202l69 201 816 2403 133 73 5841 3185 100 83 99-83 5840-3185 136-74 774-2366 66-201-6739-5716zm6262 5773-1266 1060-4144-5649 5410 4589zM2057 13582l4419-6022-2173 6948H3163l-1106-926zm558 926H1377l471-642 767 642zm4344 3124-2164-2771h4329l-2165 2771zm-6-3124H4673l2110-6751v2124h-151v601c-15 31-61 100-166 162l-86 51v1194h22c-10 18-22 33-37 45-56 35-110 75-159 117-162 140-566 628-505 1205 50 467 378 880 861 1081 85 32 222 70 391 70 166 0 330-36 493-110 429-210 724-609 770-1041 63-577-343-1065-504-1205-50-43-103-82-159-117-15-12-27-27-37-45h22v-1194l-86-51c-107-63-152-132-166-162v-601h-151V7757l2110 6751H6953zm-2606 353 1446 1850-2209-1850h763zm5223 0h764l-2211 1852 1447-1852zm44-353L7442 7560l4419 6022-1107 926H9614zm2456-642 471 642h-1239l768-642zM5955 7674l-4169 5681-1306-1095 5475-4586zM575 12799l1002 840-490 668-512-1508zm1145 2062h1316l2451 2054-3767-2054zm6710 2054 2452-2055h1315l-3767 2055zm4397-2611-487-665 972-813-485 1478z"
      style={{
        fill: "#231f20",
      }}
      className="fill"
    />
  </svg>
)
export default SvgComponent
